const extractRecommendationsParams = (personalizedPropsObj = {}) => ({
    funnelName: getFunnelName(personalizedPropsObj),
    sectionName: getSectionName(personalizedPropsObj),
});

const getFunnelName = (personalizedPropsObj) => {
    const { funnelName } = personalizedPropsObj.recommendationsParams ?? personalizedPropsObj.personalizedContent ?? {};
    const { funnelName: funnelNameFromProps } = personalizedPropsObj;

    return funnelName || funnelNameFromProps;
};

const getSectionName = (personalizedPropsObj) => personalizedPropsObj.sectionName;

module.exports = {
    extractRecommendationsParams,
};
